import {connect}  from 'react-redux';

import Question from './question';
import Result from './result';

function Quiz({nowQuestion, amountOfQuestions}) {

	if (amountOfQuestions < 1) {
		return null;
	}

	return (
		<>
			{nowQuestion < amountOfQuestions ? <Question /> : <Result />}
		</>
	);
}

const mapStateToProps = (state) =>  {
	return {nowQuestion: state.nowQuestion, amountOfQuestions: state.questions.length};
};

export default connect(mapStateToProps)(Quiz);
